import { FetcherList } from '@garpix/fetcher/fetcher-list/react-router'
import { dataStates } from '@garpix/fetcher'
import Button from '@/components/Button'
import LectureCard from '@/components/Cards/LectureCard'
import Container from '@/components/Container'
import React from 'react'
import style from '../styles/club.module.scss'
import { api } from '@/api'
import { IFetcherListResults } from '@/interfaces/Fetcher'
import { PlaceholderLoading } from '@/components/PlaceholderLoading'

const Lectures = (): React.ReactElement => {
  return (
    <FetcherList
      initFilter={{ page_size: 10 }}
      isScrollTop={false}
      isHistoryPush={false}
      api={api.getMaterialsClubUrbanists}
    >
      {({
        results,
        status,
        isNext
      }: IFetcherListResults<any[]>) => {
        return (
          <Container>
            <ul className={style.lectures_list}>
              {status === dataStates.loading
                ? (
                  <PlaceholderLoading shape='rect' width='100%' height='250px' />
                  )
                : null}
              {results.map((el) => {
                return (
                  <li key={el.id} className={style.lectures__item}>
                    <LectureCard
                      id={el.id}
                      image={el.preview_picture?.[0] ?? ''}
                      date={el.date_create}
                      title={el.name}
                      text={el.preview_text}
                    />
                  </li>
                )
              })}
            </ul>

            {isNext
              ? (
                <Button
                  disabled={status === dataStates.loading}
                  size='large'
                  wide
                  outline
                  className={style.lectures__more}
                >
                  Показать еще
                </Button>
                )
              : null}
          </Container>
        )
      }}
    </FetcherList>
  )
}

export default Lectures
